import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { MapperClassifica } from "./mapper-classifica";
import { MapperRiferimentoFascicoloEsterno } from "./mapper-riferimento-fascicolo-esterno";
import { MapperCampoSpecificoFascicolo } from "./mapper-campo-specifico-fascicolo";
import { MapperIstanzaProcedimento } from "./mapper-istanza-procedimento";
import { MapperUtente } from "./mapper-utente";

import { MapperProcedimento } from "./mapper-procedimento";
import { MapperVisibilitaFascicolo } from "./mapper-visibilita-fascicolo";
import { MapperCommento } from "./mapper-commento";
import { IperFascicoloDTO } from "../dto/iper-fascicoloDTO";
import { IperFascicoloVO } from "../vo/iper-fascicoloVO";
import { MapperStrutturaFascicolo } from "./mapper-struttura-fascicolo";
import { MapperAttivitaEreditata } from "./mapper-attivita-ereditata";
import { MapperWrapperCollegamentoFascicolo } from "./mapper-wrapper-collegamento-fascicolo";
import { AttivitaEreditataDTO } from "../dto/procedimento-ereditatoDTO";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";
import { MapperDatiRepertorioManuali } from "./mapper-dati-repertorio-manuali";
import { MapperIstanzaAttivita } from "./mapper-istanza-attivita";

@Injectable({
  providedIn: "root",
})
export class MapperIperFascicolo
  implements MapperInterface<IperFascicoloDTO, IperFascicoloVO> {
  constructor(
    private mapperTipoIstanzaFascicolo: MapperTipoIstanzaFascicolo,
    private mapperClassifica: MapperClassifica,
    private mapperStruttura: MapperStrutturaFascicolo,
    private mapperRiferimentoFascicoloEsterno: MapperRiferimentoFascicoloEsterno,
    private mapperCampoSpecificoFascicolo: MapperCampoSpecificoFascicolo,
    private mapperIstanzeProcedimento: MapperIstanzaProcedimento,
    private mapperUtente: MapperUtente,
    private mapperAttivita: MapperIstanzaAttivita,
    private mapperCommento: MapperCommento,
    private mapperAttivitaEreditate: MapperAttivitaEreditata,
    private mapperVisibilita: MapperVisibilitaFascicolo,
    private mapperWrapperFascicolo: MapperWrapperCollegamentoFascicolo,
    private mapperMetadatiRepertorio: MapperMetadatiRepertorio,
    private mapperDatiManuali: MapperDatiRepertorioManuali
  ) {}

  convertVoToDto(vo: IperFascicoloVO): IperFascicoloDTO {
    if (vo != null) {
      const dto = new IperFascicoloDTO();
      dto.id = vo.id;
      dto.tipologia = this.mapperTipoIstanzaFascicolo.convertVoToDto(
        vo.tipologia
      );
      dto.oggetto = vo.oggetto;
      dto.descrizione = vo.descrizione;

      dto.classifica = this.mapperClassifica.convertVoToDto(vo.classifica);
      dto.attivitaAssociate = this.mapperAttivita.convertVoToDto(
        vo.attivitaAssociata
      );

      dto.attivitaEreditate = this.mapperAttivitaEreditate.convertListVoToDto(
        vo.attivitaEreditate
      );

      dto.istanzeProcedimento = this.mapperIstanzeProcedimento.convertListVoToDto(
        vo.istanzeProcedimento
      );

      dto.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListVoToDto(
        vo.campiSpecifici
      );

      dto.riferimentoFascicoloEsterno = this.mapperRiferimentoFascicoloEsterno.convertVoToDto(
        vo.riferimentoFascicoloEsterno
      );
      dto.dataApertura = vo.dataApertura;
      dto.strutturaResponsabile = this.mapperStruttura.convertVoToDto(
        vo.strutturaResponsabile
      );

      dto.dataChiusura = vo.dataChiusura;
      dto.stato = vo.stato;
      dto.idFascicoliContenuti = vo.idFascicoliContenuti;
      dto.wrapperFascicoliContenuti = this.mapperWrapperFascicolo.convertListVoToDto(
        vo.wrapperFascicoliContenuti
      );
      dto.commenti = this.mapperCommento.convertListVoToDto(vo.commenti);
      dto.visibilitaIperFascicolo = this.mapperVisibilita.convertListVoToDto(
        vo.visibilitaIperFascicolo
      );

      dto.metadatiRepertorio = this.mapperMetadatiRepertorio.convertVoToDto(
        vo.metadatiRepertorio
      );
      dto.datiRepertorioManuali = this.mapperDatiManuali.convertVoToDto(
        vo.datiRepertorioManuali
      );
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: IperFascicoloDTO): IperFascicoloVO {
    console.log("[MapperIperFascicolo][convertDtoToVo]", dto);
    if (dto != null) {
      const vo = new IperFascicoloVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.id = dto.id;
      vo.tipologia = this.mapperTipoIstanzaFascicolo.convertDtoToVo(
        dto.tipologia
      );
      vo.oggetto = dto.oggetto;
      vo.descrizione = dto.descrizione;

      vo.classifica = this.mapperClassifica.convertDtoToVo(dto.classifica);
      vo.segnaturaArchivistica = dto.segnaturaArchivistica;
      vo.attivitaAssociata = this.mapperAttivita.convertDtoToVo(
        dto.attivitaAssociate
      );
      if (dto.attivitaEreditate) {
        const uniqueArray: AttivitaEreditataDTO[] = dto.attivitaEreditate.filter(
          (att, index) => {
            const att_codice = att.attivitaAssociata.codice;
            return (
              index ===
              dto.attivitaEreditate.findIndex((obj) => {
                return obj.attivitaAssociata.codice === att_codice;
              })
            );
          }
        );

        vo.attivitaEreditate = this.mapperAttivitaEreditate.convertListDtoToVo(
          uniqueArray
        );
      }

      vo.istanzeProcedimento = this.mapperIstanzeProcedimento.convertListDtoToVo(
        dto.istanzeProcedimento
      );

      vo.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListDtoToVo(
        dto.campiSpecifici
      );

      vo.riferimentoFascicoloEsterno = this.mapperRiferimentoFascicoloEsterno.convertDtoToVo(
        dto.riferimentoFascicoloEsterno
      );
      vo.dataApertura = dto.dataApertura;
      vo.dataAnnullamento = dto.dataAnnullamento;
      vo.dataChiusura = dto.dataChiusura;
      vo.strutturaResponsabile = this.mapperStruttura.convertDtoToVo(
        dto.strutturaResponsabile
      );
      vo.creatoDa = this.mapperUtente.convertDtoToVo(dto.creatoDa);
      vo.stato = dto.stato;
      vo.idFascicoliContenuti = dto.idFascicoliContenuti;
      vo.wrapperFascicoliContenuti = this.mapperWrapperFascicolo.convertListDtoToVo(
        dto.wrapperFascicoliContenuti
      );
      vo.commenti = this.mapperCommento.convertListDtoToVo(dto.commenti);
      vo.visibilitaIperFascicolo = this.mapperVisibilita.convertListDtoToVo(
        dto.visibilitaIperFascicolo
      );
      vo.metadatiRepertorio = this.mapperMetadatiRepertorio.convertDtoToVo(
        dto.metadatiRepertorio
      );
      vo.datiRepertorioManuali = this.mapperDatiManuali.convertDtoToVo(
        dto.datiRepertorioManuali
      );
      console.log("[MapperIperFascicolo][convertDtoToVo]", vo);
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: IperFascicoloVO[]): IperFascicoloDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: IperFascicoloDTO[]): IperFascicoloVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
